import {
  AlertType,
  AssignUserEvent,
  CallLightActivatedEvent,
  CallLightData,
  MovementInRoomDetectedEvent
} from "@vp/models";
import { VpNotificationTone, VpNotifyInput } from "./notification.models";

export function toCallLightNotification(
  args: CallLightActivatedEvent["args"],
  sourcePath: string
): VpNotifyInput {
  const data = args.patientConsoleDeviceData?.callLightData as CallLightData | undefined;
  // Only Urgent escalates; Reminder and Cancel resends render like Default.
  const urgent = data?.alertType === AlertType.Urgent;
  return {
    kind: urgent ? "call-light-urgent" : "call-light",
    tone: urgent ? "danger" : "warning",
    heading: args.deviceName,
    message: "",
    html: false,
    sticky: true,
    urgent: urgent,
    // The event's activationDateTime is the last-update time, which a resend moves forward;
    // the device's callLightData keeps the original activation.
    activatedAt: firstFiniteTime(data?.activatedDateTime, args.activationDateTime) ?? Date.now(),
    deviceUserId: args.deviceUserId,
    deviceName: args.deviceName,
    sourcePath: sourcePath
  };
}

export function toAssignmentNotification(args: AssignUserEvent["args"]): VpNotifyInput {
  return {
    kind: "assignment",
    tone: "info",
    heading: "New User Assignment",
    message: args.message,
    html: true,
    sticky: true,
    urgent: false
  };
}

export function toMovementNotification(args: MovementInRoomDetectedEvent["args"]): VpNotifyInput {
  return {
    kind: "movement",
    tone: movementTone(args.status?.notificationColor),
    heading: "Movement Detected",
    message: args.message,
    html: true,
    sticky: true,
    urgent: false
  };
}

export function toCaseUpdatedNotification(message: string): VpNotifyInput {
  return {
    kind: "case-updated",
    tone: "info",
    heading: "Case Updated",
    message,
    html: true,
    sticky: true,
    urgent: false
  };
}

function movementTone(notificationColor: number | undefined): VpNotificationTone {
  switch (notificationColor) {
    case 0:
      return "success";
    case 1:
      return "warning";
    case 2:
      return "danger";
    default:
      return "info";
  }
}

function firstFiniteTime(...values: (string | undefined)[]): number | undefined {
  for (const value of values) {
    const time = Date.parse(value ?? "");
    if (Number.isFinite(time)) {
      return time;
    }
  }
  return undefined;
}
